import { Box, Typography } from "@mui/material";
import CloseIcon from "../../../../../../Assets/Icons/close-outline.svg";
import AddIcon from "@mui/icons-material/Add";
import useGuestListStore from "../../../../../../stores/useGuestListStore";
import { AddGuestButton } from "./styles";
import GuestItem from "./GuestItem";

const GuestListView = () => {
  const { setOpen, guestList, setIsAddingGuest } = useGuestListStore();

  return (
    <Box>
      <Box
        padding="20px"
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Typography
          fontFamily="Plus Jakarta Sans"
          fontSize={20}
          fontWeight={700}
        >
          Guest List
        </Typography>
        <img
          src={CloseIcon}
          alt="close"
          onClick={() => setOpen(false)}
          style={{ cursor: "pointer" }}
        />
      </Box>

      <Box overflow="auto" maxHeight="500px" margin="0 10px" padding="0 10px">
        {guestList.map((guest) => (
          <GuestItem key={guest.id} {...guest} />
        ))}
        {guestList.length === 0 && (
          <Typography fontWeight={500} textAlign="center">
            No guest yet. Add a guest to your list.
          </Typography>
        )}
      </Box>

      <Box padding="20px">
        <AddGuestButton
          display="flex"
          alignItems="center"
          gap={1}
          onClick={() => setIsAddingGuest(true)}
        >
          Add Guest <AddIcon />
        </AddGuestButton>
      </Box>
    </Box>
  );
};

export default GuestListView;
